import { LinearProgress } from "@mui/material"; 
import React, { createContext,  useContext, useEffect, useReducer } from "react";  
import { useGetProductsCategoriesApi, useGetTemplateDataApi } from "template/global/hooks";
import { useCheckIfCartExistsByCustomerId } from "template/global/hooks/sale";
import { toggleTheme, useThemeDispatch } from "./ThemeContext";
import { isFidolia } from "utils";
import SEO from "components/SEO";
  
  import favicon_mybe from 'images/logo/logo_mybe.png';
  import favicon_fidolia from 'images/logo/logo_fidolia.png';
const GlobalStateContext = createContext();
const GlobalStateDispatchContext = createContext();
 
/**
 * Updates a specific value in the local storage under the key 'licencesData'.
 * 
 * @param {string} key - The key to be updated in the storage data.
 * @param {any} values - The values to set for the given key.
 */

const setValueByKey = (key, values) => {
  try {
    const codeShop = localStorage.getItem("codeShop");
  
    if (!codeShop) return; 
    let copyData = JSON.parse(localStorage.getItem("licencesData")) || {};
    copyData[codeShop] = {
      ...copyData[codeShop],
      [key]: values,
    };
    localStorage.setItem("licencesData", JSON.stringify(copyData));
  } catch (error) {
    console.error(error);
  }
};

// Initial value for the shopping cart and license data
const initialValueLicenceData = {
  user:{licences:[],codeShop:null},
  shoppingCart: {
    total: 0,
    listCategories: [],
    nbCategories: 0,
  },
  numberOfAtemps: 0,
  documentCode:null,
  oldSaleDocument:{lines:[],documentCalculationMethod:'',totalGlobalInclVatNetNetDc:0},
  saleDocument:{lines:[],documentCalculationMethod:'',totalGlobalInclVatNetNetDc:0},
  cookieConsent:null,
};
 
/**
 * Reducer function for managing settings state. 
 *
 * @param {Object} state - The current settings state.
 * @param {Object} action - The action to perform.
 * @param {string} action.type - The type of action.
 * @param {string} action.payload - The value to set for the action type.
 * @returns {Object} The updated settings state.
 */
function settingsReducer(state, action) {
  switch (action.type) {  
    case 'BASKET_DATA':{
      setValueByKey("documentCode", action.payload?.code);
      setValueByKey("saleDocument", {...initialValueLicenceData?.saleDocument,...action.payload});   
     return { ...state,licenceData:{...state?.licenceData,oldSaleDocument:{...initialValueLicenceData?.saleDocument,...state?.licenceData?.saleDocument}, saleDocument: {...initialValueLicenceData?.saleDocument,...action.payload},documentCode:action.payload?.code} };    
 
    }
    case 'OLD_BASKET_DATA':{
      setValueByKey("oldSaleDocument", {...initialValueLicenceData?.saleDocument,...state?.licenceData?.saleDocument,...action.payload});  
      return { ...state,licenceData:{...state?.licenceData, oldSaleDocument: {...initialValueLicenceData?.saleDocument,...action.payload}, saleDocument: {...initialValueLicenceData?.saleDocument}} };         
    }
    case "OPEN_SIDEBAR": 
      return { ...state, openSidebar: !state.openSidebar }; 
   case "MARGIN_TOP": 
        return { ...state, marginTop: action.payload }; 
    case "LANGUAGE":{
      localStorage.setItem("language", JSON.stringify(action.payload));
      return { ...state, language: action.payload }; 
    }    
    case  "NUMBER_OF_ATEMPS":{
      const newdata =  !action?.payload ? (state?.licenceData?.numberOfAtemps || 0) + 1 : 0; 
      setValueByKey("numberOfAtemps",newdata); 
      return { ...state,licenceData:{...state?.licenceData, numberOfAtemps: newdata} };    
      
    }
    case "TEMPLATE_DATA":{    
      return { ...state,...action.payload}; 
    }  
    case  "COOKIE_CONSENT":{
      const newdata = action?.payload ; 
      setValueByKey("cookieConsent",newdata); 
      return { ...state,licenceData:{...state?.licenceData, cookieConsent: newdata} };    
      
    }
    case  "EMAIL_RESET_PASSWORD":{ 
      setValueByKey("dataResetPassword",{email:action.payload});     
      return { ...state,licenceData:{...state?.licenceData, dataResetPassword: {email:action.payload}} };       
    }
    case "OPEN_CART_SIDEBAR": 
      return { ...state, openCartSidebar: action.payload };
    default:
      throw new Error(`Unhandled action type: ${action.type}`);
  }
} 


const BasketProvider = ({state,dispatch}) =>{
  const {isCartExist} = useCheckIfCartExistsByCustomerId(state?.licenceData?.documentCode);
// Import necessary data and methods from custom hooks (useGetProductsCategoriesApi and useGetTemplateDataApi)
const { allProductsCategories , setAllProductsCategories, getProductsCategories } = useGetProductsCategoriesApi((error)=>{

  dispatch({
    type: "TEMPLATE_DATA",
    payload: { 
      errorUpload: error , 
    },
  });
});
const { templateData, setTemplateData, getTemplateData } = useGetTemplateDataApi((error)=>{

  dispatch({
    type: "TEMPLATE_DATA",
    payload: { 
      errorUpload: error , 
    },
  });
});

const themeDispatch = useThemeDispatch();

  // First useEffect hook to trigger product categories and template data fetching when licence token is available
  useEffect(() => {
    // If licenceData contains a token, fetch product categories and template data 
    if (state?.licenceData?.token) {
      getProductsCategories();
      getTemplateData(); 
      isCartExist((state?.licenceData?.user?.licences || []).find(({licenceCode})=>(licenceCode === state?.licenceData?.codeShop))?.ecommerceCustomerId);  
    }
    // eslint-disable-next-line
  }, [state?.licenceData?.token]); // Dependencies ensure this useEffect runs when token changes
  
  // Second useEffect hook to dispatch the fetched data to the state
  useEffect(() => {
    // If both templateData and product categories are available, update the state
    if (templateData && allProductsCategories) { 
      dispatch({
        type: "TEMPLATE_DATA",
        payload: {
          templateData, // Set template data
          categories: allProductsCategories || [], // Set product categories
          isLoading: false, // Loading is set to false when data is loaded 
          errorUpload: false , 
        },
      });
      toggleTheme(themeDispatch,templateData?.templateCode);
    }
  
    //Cleanup function to reset the data when the component unmounts
    return () => {
      if (templateData && allProductsCategories) {
      setTemplateData(null); // Reset template data
      setAllProductsCategories(null); // Reset product categories  
      }
    }; 
    // eslint-disable-next-line
  }, [templateData, allProductsCategories]); // Dependencies ensure this useEffect runs when templateData or allProductsCategories changes
  
   var urlAppIcon = null; 
     var shopName = ''; 
     var banner_home_page_header_message_1 = '' ;
      var keywords = [] ; 
  


  try { 
 urlAppIcon =
  state?.templateData?.templatesettings
    ?.find(s => s?.key === "LOGO")?.url
  || (isFidolia() ? favicon_fidolia : favicon_mybe);
   } catch (error) {
    urlAppIcon = isFidolia() ? favicon_fidolia : favicon_mybe;
  }

  try { 
    banner_home_page_header_message_1 = (state?.templateData?.templatesettings || [])?.find(setting => setting?.key === 'BANNER_HOME_PAGE_HEADER_MESSAGE_1')?.value?.['FRENCH'] ;
 
  } catch (error) {
    banner_home_page_header_message_1 = '' ;
  }

  try { 
    keywords = (allProductsCategories || []).map(category=>(category?.name));
  } catch (error) {
    keywords = [shopName] ;
  } 
  try {
    shopName = state?.templateData?.commercialName || state?.licenceData?.user?.licences?.[0]?.licenceName;
  } catch (error) {
    shopName =  isFidolia() ? "Fidolia" : 'Mybe';
  } 
       
return (<> <SEO  seo={{
            title: shopName,  
            logo: urlAppIcon, 
            keywords,
            description: banner_home_page_header_message_1 || `Bienvenue sur ${shopName} – votre destination en ligne pour des produits et services de qualité`,
            }}/>  </>);

};



/**
 * Provider component for managing global state.
 * Provides context for settings state and dispatch function.
 *
 * @param {Object} props - The component props.
 * @param {React.ReactNode} props.children - The child components to render.
 * @returns {JSX.Element} The `GlobalStateProvider` component.
 */
const GlobalStateProvider = ({ children }) => {

const [state, dispatch] = useReducer(settingsReducer, undefined, () => {
  const licencesData = JSON.parse(localStorage.getItem("licencesData")) || {};
  const codeShop = localStorage.getItem("codeShop");
  const storedLicence = licencesData?.[codeShop];

  return {
    openSidebar: false,
    openCartSidebar: false,
    marginTop: "70px",
    isLoading: true,
    categories: [],
    numberOfAtemps: JSON.parse(localStorage.getItem("numberOfAtemps")) || 0,
    templateData: {
      deliveryDeadline: 2,
      currency: {
        symbol: "€",
        precision: 2,
        templateCode: null,
        templatePages: [],
        templatesettings: [],
      },
    },
    language: JSON.parse(localStorage.getItem("language")) || "FRENCH",
    errorUpload: false,
    licenceData: storedLicence && codeShop
      ? { ...initialValueLicenceData, ...storedLicence, codeShop }
      : initialValueLicenceData,
  };
});



  return (
    <GlobalStateContext.Provider value={state}>
      <GlobalStateDispatchContext.Provider value={dispatch}>  
      <BasketProvider state={state} dispatch={dispatch}/>
       {(!state?.isLoading || !state?.licenceData?.token || !!state?.errorUpload) ? <>
        {children} </> : <>  <LinearProgress color="inherit" /> </>}
      </GlobalStateDispatchContext.Provider>
    </GlobalStateContext.Provider>
  );
};

/**
 * Hook to access the settings state.
 * Throws an error if used outside of `GlobalStateProvider`.
 *
 * @returns {Object} The settings state.
 */
const useGlobalState = () => {
  const context = useContext(GlobalStateContext);
  if (context === undefined) {
    throw new Error("useGlobalState must be used within a GlobalStateProvider");
  }
  return context;
};

/**
 * Hook to access the settings dispatch function.
 * Throws an error if used outside of `GlobalStateProvider`.
 *
 * @returns {Function} The settings dispatch function.
 */
const useGlobalStateDispatch = () => {
  const context = useContext(GlobalStateDispatchContext);
  if (context === undefined) {
    throw new Error("useGlobalStateDispatch must be used within a GlobalStateProvider");
  }
  return context;
};
 
/**
 * Dispatches an action to update the global state. 
 *
 * @param {Function} dispatch - The dispatch function from `useReducer`.
 * @param {Object} payload - The payload to update in the state.
 */
const setGlobalStateOpenSidebar = (dispatch, payload) => {  
  dispatch({
    type: "OPEN_SIDEBAR",
    payload: payload,
  });
};
/**
 * Dispatches an action to update the global state. 
 *
 * @param {Function} dispatch - The dispatch function from `useReducer`.
 * @param {Object} payload - The payload to update in the state.
 */
const setGlobalStateMarginTop = (dispatch, payload) => {  
  dispatch({
    type: "MARGIN_TOP",
    payload: payload,
  });
};

const setShoppingCart = (dispatch, payload) => {  
  dispatch({
    type: "SHOPPING_CART",
    payload: payload,
  });
};
const setLanguage = (dispatch, payload) => {  
  dispatch({
    type: "LANGUAGE",
    payload: payload,
  });
};
const setNumberOfAtemps = (dispatch, payload) => {  
  dispatch({
    type: "NUMBER_OF_ATEMPS",
    payload: payload,
  });
};
const setBasket = (dispatch, payload) => {  
  dispatch({
    type: "BASKET_DATA",
    payload: payload,
  });
};
const setOldBasket = (dispatch, payload) => {  
  dispatch({
    type: "OLD_BASKET_DATA",
    payload: payload,
  });
};
const setCookieConsent= (dispatch, payload) => {  
  dispatch({
    type: "COOKIE_CONSENT",
    payload: payload,
  });
};
const setEmailResetPassword = (dispatch, payload) => {  
  dispatch({
    type: "EMAIL_RESET_PASSWORD",
    payload: payload,
  });
}
const setGlobalStateOpenCartSidebar = (dispatch, payload) => {  
  dispatch({
    type: "OPEN_CART_SIDEBAR",
    payload: payload,
  });
}

export { 
   GlobalStateProvider, 
   useGlobalState, 
   useGlobalStateDispatch,
   setGlobalStateOpenSidebar,
   setGlobalStateMarginTop,
   setShoppingCart,
   setLanguage,setEmailResetPassword,setGlobalStateOpenCartSidebar,
   setNumberOfAtemps,setBasket,setOldBasket,setCookieConsent};
 